import styles from "./index.module.css";
import PopupModal from "../../../../Components/PopupModal";
import FakeButton from "../../../../Components/FormComponents/FakeButton";
import { Link } from "react-router";

export default function ConfirmExit({ close }) {
  return (
    <PopupModal close={close} contentClassName={styles.content}>
      <div className={styles.title}>Точно хочеш вийти?</div>
      <div className={styles.text}>
        Твої відповіді не збережуться — тест доведеться проходити з початку.
      </div>
      <div className={styles.actions}>
        <FakeButton className={styles.stay} onClick={close} red>
          Продовжити тест
        </FakeButton>
        <Link to={"/"} className={styles.leave}>
          Все одно вийти
        </Link>
      </div>
    </PopupModal>
  );
}
